const BUY_BUTTON_CLASS = 'js-product-buy-button'
const AUTH_BUTTON_CLASS = 'js-fc-auth-button'
const AUTH_GUARD_CLASS = 'js-fc-authguard'
const SELLING_PERIOD_DURING_CLASS = 'ruffruff-selling-periods__product-message__during-selling-period'
const SELLING_PERIOD_AFTER_CLASS = 'ruffruff-selling-periods__product-message__after-selling-period'
const SELLING_PERIOD_BEFORE_CLASS = 'ruffruff-selling-periods__product-message__before-selling-period'
const primaryLocale = 'ja'

const {
  FC_AUTH_URL,
  FC_ALLOW_REFS,
  FC_BUTTON_LABEL,
  FC_DEFAULT_LINK_PW,
  FC_LINK_PW,
} = window.fcAuthSettings

const FC_PW = FC_LINK_PW || FC_DEFAULT_LINK_PW

const { FC_SIGNIN_URLS } = fcAuthSettings

const REFERER_URLS = Object.values(FC_ALLOW_REFS).map(url => getOrigin(url))

const FC_SIGNIN_URL = getOrigin(FC_AUTH_URL) === getOrigin(FC_ALLOW_REFS.stg) ? FC_SIGNIN_URLS.stg : FC_SIGNIN_URLS.prod
// セッションストレージに設定された言語にリダイレクト
const redirectToLocale = () => {
  const sessionLocale = sessionStorage.getItem('locale')
  if ((!sessionLocale || sessionLocale === "")) return

  const { isPrimaryLocale, locale } = window.variantStrings

  if (sessionLocale === locale) return

  const { pathname, origin, search } = window.location
  const pathnames = pathname.split('/')

  if (isPrimaryLocale) {
    pathnames[1] = `${sessionLocale}/${pathnames[1]}`
  }
  else if (sessionLocale === primaryLocale) {
    pathnames.splice(1, 1)
  }
  else {
    pathnames[1] = sessionLocale
  }

  const newPathname = pathnames.join('/')

  const redirectUrl = `${origin}${newPathname}${search}`

  // セッションストレージをリセット
  sessionStorage.removeItem('locale')

  window.location.href = redirectUrl
}

// ファンクラブ経由どうかを判定する関数（参照元URLとクエリパラメータのパスワードで判定）
function isFanclubReferer() {
  // セッションストレージの認証ステータスを確認する
  const urlParams = new URLSearchParams(window.location.search)
  const password = urlParams.get('link_pw')
  const referrer = getOrigin(document.referrer)

  if (FC_PW !== '' && FC_PW !== null) {

    const sessionLinkPass = sessionStorage.getItem('fanclub_auth_pw')
    if (sessionLinkPass === FC_PW) {
      return true
    }

    // パスワードが一致し、参照元URLが指定されたURLと一致する場合
    if (REFERER_URLS.includes(referrer) && password === FC_PW) {
      // セッションストレージに認証ステータスを保存
      sessionStorage.setItem('fanclub_auth_pw', password)
      return true
    }
  
    if (REFERER_URLS.includes(sessionStorage.getItem('fanclub_auth_referrer_history')) && sessionStorage.getItem('fanclub_auth_pw_history') === FC_PW) {
      // セッションストレージに認証ステータスを保存　
      sessionStorage.setItem('fanclub_auth_pw', sessionStorage.getItem('fanclub_auth_pw_history'))
      return true
    }
  }

  if (password && referrer && REFERER_URLS.includes(referrer)) {
    // セッションストレージに認証ステータスを保存
    sessionStorage.setItem('fanclub_auth_pw_history', password)
    sessionStorage.setItem('fanclub_auth_referrer_history', referrer)
  }

  return false
}

isFanclubReferer()

function ensureAuthButtons() {
  const buyButtons = document.querySelectorAll(`.${BUY_BUTTON_CLASS}:not(.${AUTH_BUTTON_CLASS})`)
  Array.from(buyButtons).forEach((buyButton) => {
    const existingAuthButtons = buyButton.parentNode.querySelectorAll(`.${AUTH_BUTTON_CLASS}`)
    if (existingAuthButtons.length) return

    // fc_debug パラメータが付いている場合は FC_AUTH_URL にも引き継ぎ、認証後のデバッグパネルを維持する
    const currentDebugParam = new URLSearchParams(window.location.search).get('fc_debug')
    let authReturnUrl = FC_AUTH_URL
    if (currentDebugParam) {
      const sep = authReturnUrl.includes('?') ? '&' : '?'
      authReturnUrl = `${authReturnUrl}${sep}fc_debug=${encodeURIComponent(currentDebugParam)}`
    }
    const redirectUrl = encodeURIComponent(authReturnUrl)
    const { locale, fcAuthPrivateBrowsingNotice } = window.variantStrings

    const aTag = document.createElement('a')
    aTag.href = `${FC_SIGNIN_URL}?url=${redirectUrl}&lang=${locale}`
    aTag.className = `${buyButton.className} ${AUTH_BUTTON_CLASS}`
    aTag.textContent = FC_BUTTON_LABEL
    aTag.style.display = 'none'
    aTag.onclick = () => {
      sessionStorage.setItem('locale', locale)
      // デバッグモード中に認証ボタンを押した場合、FC認証後の固定URLでもパネルを表示できるようフラグを立てる
      if (new URLSearchParams(window.location.search).get('fc_debug') === '1') {
        sessionStorage.setItem('fc_debug_pending', '1')
      }
    }

    buyButton.parentNode.appendChild(aTag)

    if (fcAuthPrivateBrowsingNotice && !buyButton.parentNode.querySelector('.fc-auth-private-browsing-notice')) {
      const notice = document.createElement('p')
      notice.className = 'fc-auth-private-browsing-notice'
      notice.textContent = fcAuthPrivateBrowsingNotice
      buyButton.parentNode.appendChild(notice)
    }
  })
}

function canShowFanclubAuthBySellingPeriod() {
  const hasDuringSellingPeriod = document.getElementsByClassName(SELLING_PERIOD_DURING_CLASS).length > 0
  const hasBeforeSellingPeriod = document.getElementsByClassName(SELLING_PERIOD_BEFORE_CLASS).length > 0
  const hasAfterSellingPeriod = document.getElementsByClassName(SELLING_PERIOD_AFTER_CLASS).length > 0

  if (hasBeforeSellingPeriod || hasAfterSellingPeriod) return false
  if (hasDuringSellingPeriod) return true

  return true
}

function toggleButtonsByState({ available }) {
  const buyButtons = document.querySelectorAll(`.${BUY_BUTTON_CLASS}:not(.${AUTH_BUTTON_CLASS})`)
  const authButtons = document.getElementsByClassName(AUTH_BUTTON_CLASS)
  const noticeElements = document.getElementsByClassName('fc-auth-private-browsing-notice')
  const isAvailable = available ?? window.fcAuthSettings?.IS_AVAILABLE

  if (!canShowFanclubAuthBySellingPeriod()) {
    Array.from(authButtons).forEach((button) => (button.style.display = 'none'))
    Array.from(buyButtons).forEach((button) => (button.style.display = ''))
    Array.from(noticeElements).forEach((notice) => (notice.style.display = 'none'))
    return
  }

  if (isAvailable === false) {
    Array.from(authButtons).forEach((button) => (button.style.display = 'none'))
    Array.from(buyButtons).forEach((button) => (button.style.display = ''))
    Array.from(noticeElements).forEach((notice) => (notice.style.display = 'none'))
    return
  }

  const isAuthenticated = isFanclubReferer()
  if (isAuthenticated) {
    Array.from(authButtons).forEach((button) => (button.style.display = 'none'))
    Array.from(buyButtons).forEach((button) => (button.style.display = ''))
    Array.from(noticeElements).forEach((notice) => (notice.style.display = 'none'))
    return
  }

  Array.from(buyButtons).forEach((button) => (button.style.display = 'none'))
  Array.from(authButtons).forEach((button) => (button.style.display = ''))
  Array.from(noticeElements).forEach((notice) => (notice.style.display = ''))
}

function watchSellingPeriodState() {
  if (!document.body) return

  const hasSellingPeriodClass = (node) => {
    if (!(node instanceof Element)) return false

    if (
      node.classList.contains(SELLING_PERIOD_DURING_CLASS) ||
      node.classList.contains(SELLING_PERIOD_BEFORE_CLASS) ||
      node.classList.contains(SELLING_PERIOD_AFTER_CLASS)
    ) {
      return true
    }

    return !!node.querySelector(
      `.${SELLING_PERIOD_DURING_CLASS}, .${SELLING_PERIOD_BEFORE_CLASS}, .${SELLING_PERIOD_AFTER_CLASS}`
    )
  }

  const observer = new MutationObserver((mutations) => {
    const hasTargetMutation = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => hasSellingPeriodClass(node))
    )

    if (!hasTargetMutation) return
    toggleButtonsByState({ available: window.fcAuthSettings?.IS_AVAILABLE })
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

// URLに ?fc_debug=1 が付いている場合に認証診断パネルを表示する
// サポート対応用：問題のあるお客様に「URLの末尾に ?fc_debug=1 を付けて認証を試みてスクリーンショットをお送りください」と案内する
// 診断コードのデコード方法（サポートスタッフ用）:
//   JSON.parse(decodeURIComponent(atob( コード.replace('fc_dbg_', '') )))
function showFcAuthDebugPanel() {
  const debugInUrl = new URLSearchParams(window.location.search).get('fc_debug') === '1'
  const debugPending = sessionStorage.getItem('fc_debug_pending') === '1'
  // fc_debug=1 がURLにある場合 または 認証するボタン押下後のページの場合に表示
  if (!debugInUrl && !debugPending) return
  // fc_debug_pending は1度表示したらクリア（次のページには引き継がない）
  sessionStorage.removeItem('fc_debug_pending')

  const linkPw = new URLSearchParams(window.location.search).get('link_pw')

  function storageAvailable(storage) {
    try { storage.setItem('_fc_test', '1'); storage.removeItem('_fc_test'); return 1 } catch (e) { return 0 }
  }

  // 2段階前のリファラを取得してから履歴を更新する
  // ref  = 現在ページの直前リファラ（FC認証後なら FC サイトのURL）
  // ref2 = 認証するボタンを押す前のページ時点での referrer
  const ref2 = sessionStorage.getItem('fc_dbg_ref1') || ''
  sessionStorage.setItem('fc_dbg_ref2', ref2)
  sessionStorage.setItem('fc_dbg_ref1', document.referrer || '')

  const isAuth = isFanclubReferer()

  // 診断データを数値フラグとして収集し、お客様に内容が読めない形でエンコードする
  const diagData = {
    // パスワード関連
    pw:       FC_PW ? 1 : 0,
    pw_src:   FC_LINK_PW ? 'product' : (FC_DEFAULT_LINK_PW ? 'default' : 'none'), // 商品個別 or グローバルデフォルト
    pw_hint:  FC_PW ? FC_PW.substring(0, 4) : '',       // FC_PW の先頭4文字（link_pw との比較用）
    lpw:      linkPw ? 1 : 0,
    lpw_hint: linkPw ? linkPw.substring(0, 4) : '',     // URL の link_pw の先頭4文字
    match:    (linkPw && FC_PW) ? (linkPw === FC_PW ? 1 : 0) : -1,
    // リファラ
    ref:      document.referrer || '',
    ref2:     ref2,
    // ストレージ
    ss:       storageAvailable(sessionStorage),
    ls:       storageAvailable(localStorage),
    stored:   sessionStorage.getItem('fanclub_auth_pw') ? 1 : 0,
    // 設定・環境
    env:      getOrigin(FC_AUTH_URL) === getOrigin(FC_ALLOW_REFS.stg) ? 'stg' : 'prod', // STG/PROD判定
    fc_url:   FC_AUTH_URL ? 1 : 0,                      // FC_AUTH_URL が設定されているか
    avail:    window.fcAuthSettings?.IS_AVAILABLE,       // バリアントの在庫状況（falseなら購入ボタンを在庫切れで表示）
    // 認証結果
    auth:     isAuth ? 1 : 0,
  }

  let diagCode = 'fc_dbg_error'
  try {
    diagCode = 'fc_dbg_' + btoa(encodeURIComponent(JSON.stringify(diagData)))
  } catch (e) {}

  // パネル本体
  const panel = document.createElement('div')
  panel.id = 'fc-auth-debug-panel'
  panel.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#111;color:#eee;font-family:monospace;font-size:13px;padding:12px 16px;z-index:99999;border-top:2px solid #f90;'

  const closeBtn = document.createElement('span')
  closeBtn.textContent = '✕ 閉じる'
  closeBtn.style.cssText = 'float:right;cursor:pointer;color:#aaa'
  closeBtn.onclick = () => panel.remove()

  const title = document.createElement('strong')
  title.style.color = '#f90'
  // title.textContent = 'FC Auth デバッグ'

  const statusLine = document.createElement('div')
  statusLine.style.margin = '4px 0'
  statusLine.innerHTML = `認証状態: <span style="color:${isAuth ? '#4f4' : '#f44'}">${isAuth ? '✓ 認証済み' : '✗ 未認証'}</span>`

  const codeLabel = document.createElement('div')
  codeLabel.style.cssText = 'color:#aaa;font-size:11px;margin-top:6px'
  codeLabel.textContent = '診断コード（サポートへコピーしてお送りください）'

  const codeRow = document.createElement('div')
  codeRow.style.marginTop = '3px'

  const codeSpan = document.createElement('span')
  codeSpan.style.cssText = 'font-size:11px;word-break:break-all;color:#ff0'
  codeSpan.textContent = diagCode

  const copyBtn = document.createElement('button')
  copyBtn.textContent = 'コピー'
  copyBtn.style.cssText = 'margin-left:8px;padding:2px 8px;font-size:11px;cursor:pointer;vertical-align:middle'
  copyBtn.onclick = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(diagCode).then(() => { copyBtn.textContent = 'コピー済み！' })
    } else {
      const ta = document.createElement('textarea')
      ta.value = diagCode
      ta.style.cssText = 'position:fixed;opacity:0'
      document.body.appendChild(ta)
      ta.focus(); ta.select()
      document.execCommand('copy')
      ta.remove()
      copyBtn.textContent = 'コピー済み！'
    }
  }

  codeRow.appendChild(codeSpan)
  codeRow.appendChild(copyBtn)
  panel.appendChild(closeBtn)
  panel.appendChild(title)
  panel.appendChild(statusLine)
  panel.appendChild(codeLabel)
  panel.appendChild(codeRow)
  document.body.appendChild(panel)
}

// ファンクラブ認証ガードが有効になっている商品ページの場合は、認証済みかを判定して購入ボタンをファンクラブログインページへのaタグに書き換える
async function handleFanclubAuthGuard() {
  const authGuard = document.querySelector(`.${AUTH_GUARD_CLASS}`)
  if (!authGuard) return
  redirectToLocale()

  ensureAuthButtons()
  toggleButtonsByState({ available: window.fcAuthSettings?.IS_AVAILABLE })
  showFcAuthDebugPanel()
  watchSellingPeriodState()

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const available = event?.data?.variant?.available
      if (window.fcAuthSettings) {
        window.fcAuthSettings.IS_AVAILABLE = available
      }
      toggleButtonsByState({ available })
    })
  }
}

handleFanclubAuthGuard()


function getOrigin(url) {
  try {
    return new URL(url).origin
  } catch (e) {
    console.error('Invalid URL:', url)
    return ''
  }
}

